export const common = {
  language: 'Language',
  tryAgain: 'Try again',
  close: 'Close',
  cancel: 'Cancel',
  send: 'Send',
  sending: 'Sending…',
  viewAll: 'View all',
  logoAlt: 'Whatzneu Finance',
  wealthAlt: 'Money, lending, and wealth',
  errors: {
    generic: "We couldn't load your information right now. Please try again.",
    timeout: "We couldn't reach Whatzneu Finance in time. Please try again.",
    offline: 'No internet connection.',
    sessionExpired: 'Your session has expired. Please sign in again.',
    checkDetails: 'Please check the details and try again.',
  },
  terms: {
    status: {
      ACTIVE: 'Active',
      APPROVED: 'Approved',
      DISBURSED: 'Disbursed',
      ONBOARDED: 'Onboarded',
      CLOSED: 'Closed',
      PENDING: 'Pending',
      SUBMITTED: 'Submitted',
      IN_REVIEW: 'In review',
      CONTACTED: 'Contacted',
      DECLINED: 'Declined',
      REJECTED: 'Rejected',
      WRITTEN_OFF: 'Written off',
      MATURED: 'Matured',
      INACTIVE: 'Inactive',
      RECORDED: 'Recorded',
    },
    paymentType: {
      REPAYMENT: 'Repayment',
      INTEREST: 'Interest',
      TOP_UP: 'Top-up',
      LATE_FEE: 'Late fee',
    },
    debitType: {
      LOAN_ON_INTEREST: 'Interest-only facility',
      EMI: 'EMI facility',
    },
    duration: {
      DAILY: 'Daily',
      WEEKLY: 'Weekly',
      MONTHLY: 'Monthly',
      YEARLY: 'Yearly',
    },
    category: {
      FINANCIAL_PRODUCTS: 'Financial products',
      SAAS: 'SaaS',
      CONSULTING_SERVICES: 'Consulting services',
      CLOTHES: 'Clothes',
    },
    notificationType: {
      LOAN_OPENED: 'Facility opened',
      PAYMENT_REMINDER: 'Payment reminder',
    },
  },
};
